import { Injectable } from '@angular/core';
import { AuthService } from '@auth/auth.service';
import { toTimestamp } from '@core/_utils/date.utils';
import { b64DecodeUnicode, getParseToken, getStorageToken } from '@core/_utils/tools.utils';
import { tokenName } from '@documalis/_const/const';

@Injectable()
export class TokenService {
    public userName: string;
    public userFirstLastName: string;
    public clientName: string;
    public currentToken: string;
    public clientId: string;
    public entityId: string;
    public login: string;
    private tokenDecoded;

    constructor(private auth: AuthService) {
        this.getToken();
    }

    public setToken(token) {
        localStorage.setItem(tokenName, atob(token));
        this.setValues();
    }

    private getToken() {
        this.currentToken = '';
        if (getStorageToken()) {
            const token = getParseToken();
            if (token) {
                const exp = token.exp * 1000;
                const date = toTimestamp(new Date());
                if (exp <= date) {
                    this.auth.clearStorage();
                    return false;
                }
                this.currentToken = token.token;
                this.setValues();
            }
        }
    }

    public setValues() {
        this.tokenDecoded = this.getTokenInfo();
        this.userName = this.getUserName();
        this.clientName = this.getClientName();
        this.clientId = this.getClientId();
        this.entityId = this.getEntityId();
        this.userFirstLastName = this.getFirstLastName();
        this.login = this.tokenDecoded.user;
    }

    private getTokenInfo() {
        const token = getParseToken();
        if (token) {
            return this.decodeToken(token.token);
        } else {
            return null;
        }
    }

    private decodeToken(data) {
        let value = data;
        value = value.split('.')[1];
        value = value.replace('-', '+').replace('_', '/');
        value = JSON.parse(b64DecodeUnicode(value));
        return value;
    }

    public getUserName() {
        return this.auth.getUser();
    }

    public getFirstLastName() {
        return this.auth.getUserFirstLastName();
    }

    public getClientName() {
        if (!this.tokenDecoded) {
            return '';
        }
        if (!this.tokenDecoded.client) {
            return '';
        }
        return this.tokenDecoded ? `${this.tokenDecoded.client.name}` : '';
    }

    public getClientId() {
        if (!this.tokenDecoded) {
            return '';
        }
        if (!this.tokenDecoded.client) {
            return '';
        }
        return this.tokenDecoded ? `${this.tokenDecoded.client.id}` : '';
    }

    public getEntityId() {
        if (!this.tokenDecoded) {
            return '';
        }
        if (!this.tokenDecoded.entity) {
            return '';
        }
        return this.tokenDecoded ? `${this.tokenDecoded.entity.id}` : '';
    }
}
